module.exports = __webpack_public_path__ + "img/me-night-top-bg_en.3472c70a.png";